import React from 'react';
import HelpLink from 'components/pure/admin/HelpLink';

export default class ReasonSchemeFormDialogHelp extends React.PureComponent {
  render() {
    return (
      <HelpLink popoverClassName={'department-profile-help-text'}>
        <p>Each of the answers can have multiple reasons.</p>
        <p>Write your reasons in such a way to fit the scoring answer.</p>
        <p>Click "Add Reason/s" or "Add more" to add a new reason.</p>
        <p>Remove the reason text and click anywhere in the form to remove the reason.</p>
        <p>Set the "Require a reason" if the scheme should be required for the question.</p>
        <p>Once you are happy with the questions, click "Save" to save your changes.</p>
      </HelpLink>
    );
  }
}
